var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentComponent)?_c('div',{staticClass:"transaction-list"},[_c('el-card',[_c(_vm.currentComponent,{ref:"transactionListComponent",tag:"component",attrs:{"filters":_vm.filters},on:{"refresh-loan-totalizers":function($event){return _vm.$emit('refresh-loan-totalizers')}}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }